// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"index-module--footerContainer--hkEWi","link":"index-module--link--39Qfi","logo":"index-module--logo--3Rc2e"};